import React from 'react'
import './tag.less'
interface Props {
    suffix: string
}
export const TagMarker: React.FC<Props> = ({ suffix }) => {
    const getColor = () => {
        switch (suffix) {
            case 'plan':
                return { type: '教案', color: '#ff4d4f' }
            case 'ppt':
                return { type: '课件', color: '#ffa400' }
            case 'doc':
                return { type: '文档', color: '#2adea0' }
            case 'res':
                return { type: '资源', color: '#048edc' }
            default:
                return { type: '其他', color: '#adadae' }
        }
    }

    return (
        <>
            <div className="tag-marker" style={{ backgroundColor: `${getColor().color}` }}>
                {getColor().type}
            </div>
        </>
    )
}
